import { Badge } from "@mantine/core";

export const BadgeOverwrite = Badge.extend({
  styles: () => ({
    root: {
      textTransform: "none",
      borderWidth: 1,
    },
  }),
});
